/**
 * AdminOrdersPage — Iter 156.10
 * Thin shell: composes `useAdminOrders` state with sub-components in /admin-orders.
 */
import React from "react";
import useAdminOrders from "./admin-orders/useAdminOrders";
import AdminOrdersHeader from "./admin-orders/AdminOrdersHeader";
import AdminOrdersFilters from "./admin-orders/AdminOrdersFilters";
import AdminOrdersTable from "./admin-orders/AdminOrdersTable";
import EditOrderModal from "./admin-orders/EditOrderModal";
import CreateOrderModal from "./admin-orders/CreateOrderModal";
import PlacedOrderModal from "./admin-orders/PlacedOrderModal";

export default function AdminOrdersPage() {
  const s = useAdminOrders();

  return (
    <div className="min-h-screen bg-[--bg-cream] p-4 md:p-6" data-testid="admin-orders-page">
      <AdminOrdersHeader
        total={s.pagination.total}
        searchQuery={s.searchQuery}
        setSearchQuery={s.setSearchQuery}
        showFilters={s.showFilters}
        setShowFilters={s.setShowFilters}
        onPlacedOrderClick={() => s.setShowPlacedOrderModal(true)}
        onCreateOrderClick={() => s.setShowCreateModal(true)}
      />

      {s.showFilters && (
        <AdminOrdersFilters
          filters={s.filters}
          setFilters={s.setFilters}
          filterOptions={s.filterOptions}
        />
      )}

      <AdminOrdersTable
        loading={s.loading}
        filteredOrders={s.filteredOrders}
        pagination={s.pagination}
        setPagination={s.setPagination}
        onEdit={(order) => { s.setEditingOrder(order); s.setEditForm(order); }}
        onDelete={s.handleDeleteOrder}
      />

      <EditOrderModal
        editingOrder={s.editingOrder}
        editForm={s.editForm}
        setEditForm={s.setEditForm}
        onClose={() => s.setEditingOrder(null)}
        onSave={s.handleUpdateOrder}
      />

      <CreateOrderModal
        open={s.showCreateModal}
        createForm={s.createForm}
        setCreateForm={s.setCreateForm}
        saving={s.saving}
        onClose={() => s.setShowCreateModal(false)}
        onSave={s.handleCreateOrder}
      />

      <PlacedOrderModal
        open={s.showPlacedOrderModal}
        placedForm={s.placedForm}
        setPlacedForm={s.setPlacedForm}
        saving={s.saving}
        onClose={() => s.setShowPlacedOrderModal(false)}
        onSave={s.handlePlacedOrder}
      />
    </div>
  );
}
